import React, { useState } from 'react';
import { Button, Modal, ModalProps } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { createModal } from 'react-modal-promise';

type Props = {
  readonly open: boolean;
  readonly close: (result: any) => void;
  readonly title: string;
  /** body of dialog */
  readonly text: string | React.ReactNode;
  /** accept text */
  readonly acceptText?: string;
  /** deny text */
  readonly denyText?: string;
  readonly type?: string;
} & ModalProps;

const ModalInput = ({
  open,
  close,
  title,
  text,
  acceptText,
  denyText,
  type = 'text',
}: Props) => {
  const { t } = useTranslation();
  acceptText = acceptText ? acceptText : t('OK');
  denyText = denyText ? denyText : t('CANCEL');
  const [input, setInput] = useState('');

  const handleChange = (e) => {
    setInput(e.target.value);
  };
  return (
    <>
      <Modal show={open} centered backdrop="static">
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label>{text}</label>
          <input
            className="form-control"
            onChange={handleChange}
            type={type}
            value={input}
            ref={(el) => {
              if (el) el.focus();
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="p-3"
            style={{ minWidth: '5rem' }}
            variant="primary"
            onClick={() => close(input)}
          >
            &nbsp;{acceptText}&nbsp;
          </Button>
          <Button
            className="p-3"
            style={{ minWidth: '5rem' }}
            variant="danger"
            onClick={() => close(false)}
          >
            &nbsp;{denyText}&nbsp;
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const promiseModalInput = createModal(ModalInput);

export default promiseModalInput;

